<template>
  <div class="flex">
    <label
      v-for="(opt, idx) in options"
      :key="opt.value.toString()"
      v-tippy="{ content: opt.tooltip || null, delay: 400, placement: opt.tooltipPlacement || 'top' }"
      :data-testId="opt.dataTestId"
      class="group relative flex min-h-8 min-w-8 cursor-pointer select-none items-center justify-center gap-2 text-nowrap border px-2"
      :class="[
        idx === 0 && 'rounded-l',
        idx !== 0 && 'border-l-0',
        idx === options.length - 1 && 'rounded-r',
        modelValue === opt.value
          ? 'bg-active-secondary text-active-primary border-active-secondary hover:bg-active-secondary-hover hover:border-active-secondary-hover'
          : 'border-gray-30 hover:bg-gray-20 hover:border-gray-20 bg-white',
        opt.disabled && 'bg-gray-20 pointer-events-none text-gray-50',
        !opt.icon && 'px-4',
      ]"
      tabindex="0"
      role="button"
      @click="updateValue(opt.value, $event)"
      @keyup.enter.exact="updateValue(opt.value, $event)"
      @keyup.space.exact="updateValue(opt.value, $event)"
    >
      <span v-if="opt.label" class="pointer-events-none text-sm font-bold">{{ opt.label }}</span>
      <input type="radio" :disabled="opt.disabled" class="invisible fixed" :value="opt.value" />
      <component
        :is="opt.icon"
        v-if="opt.icon"
        :class="[
          'text-button-primary-icon group-hover:text-button-primary-icon-hover h-4 w-4',
          opt.iconClass,
          modelValue === opt.value ? '!text-button-primary-icon-active' : 'text-button-primary-icon',
          opt.disabled && 'text-gray-50',
        ]"
      />
    </label>
  </div>
</template>

<script setup lang="ts" generic="T extends string | boolean">
import type { FeatherIconComponent } from 'vue3-feather'

const props = defineProps<{
  modelValue?: T
  options: {
    value: T
    label?: string
    icon?: FeatherIconComponent
    dataTestId?: string
    iconClass?: string
    disabled?: boolean
    tooltip?: string
    tooltipPlacement?: string
  }[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: T | undefined): void
}>()

function updateValue(val: T, evt: MouseEvent | KeyboardEvent) {
  if (evt.target instanceof HTMLElement && evt.target.tagName !== 'LABEL') return
  emit('update:modelValue', val === props.modelValue ? undefined : val)
}
</script>
